module.exports = "<app-loader></app-loader>\r\n<app-header></app-header>\r\n<div>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main